import Model, { hasMany } from "@ember-data/model";
import type Store from "@ember-data/store";
import type ModelRegistry from "@ember-data/types/registries/model";
import { service } from "@ember/service";
export default class TherapeuticalArea extends Model {
  @hasMany("follow-up-reason", { async: false, inverse: "therapeuticalArea" })
  declare followUpReasons: Array<ModelRegistry["follow-up-reason"]>;

  @hasMany("image", { async: false, inverse: "therapeuticalAreas" })
  declare images: Array<ModelRegistry["image"]>;

  @hasMany("adverse-event", { async: false, inverse: "therapeuticalAreas" })
  declare adverseEvents: Array<ModelRegistry["adverse-event"]>;

  @hasMany("priority-bio-exam", { async: false, inverse: "therapeuticalAreas" })
  declare priorityBioExams: Array<ModelRegistry["priority-bio-exam"]>;

  @hasMany("default-bio-exam", { async: false, inverse: "therapeuticalAreas" })
  declare defaultBioExams: Array<ModelRegistry["default-bio-exam"]>;

  @service declare store: Store;

  get productDisplayName(): string {
    return this.id.charAt(0).toUpperCase() + this.id.slice(1) + "Wise";
  }
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "therapeutical-area": TherapeuticalArea;
  }
}
